import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Error404Image from "../../assets/images/error-404.jpg";
import { dispatch } from "../../store";

export default function General404({ slug }) {
  const navigate = useNavigate();
  const goBack = () => navigate(-1);

  //   useEffect(() => {
  //     dispatch.loading.hide();
  //   }, []);

  return (
    <div class={`error-404-page ${slug && "general"}`}>
      <div class="page-wrapper">
        <div id="page-content product-404">
          <div class="container">
            <div class="row">
              <div class="col-12 text-center">
                <div class="error-content py-4">
                  <img src={Error404Image} alt="error-404" />
                  <div class="page-title">
                    <h1>404 - {slug} NOT FOUND</h1>
                  </div>
                  <p>We can't seem to find page you are looking for.</p>
                  <p>
                    <button
                      onClick={goBack}
                      class="btn btn-outline-primary rounded text-capitalize mb-2 me-2">
                      Go Back
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
